import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faEnvelope, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useMediaQuery } from 'react-responsive';
import './Header.css';

const Header: React.FC = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-top">
        <span className="company-address">
          Proco Company, 8220 Birch St, Manassas, VA 20111, US
        </span>
      </div>

      <div className="header-content">
        <div className="logo-with-text">
          <img src={require("../assets/logo.jpg")} alt="PROCO Logo" className="logo-img" />
          <div className="logo-text">
            PROCO Company <br />
            <small>Established 1999</small>
          </div>
        </div>

        {!isMobile ? (
          <div className="contact-social">
            <div className="contact-info">
              <p>Contact us today</p>
              <p>
                <FontAwesomeIcon icon={faPhoneAlt} /> Tel: 703-396-TIRE (8473) <br />
                <FontAwesomeIcon icon={faEnvelope} /> Email: info@prococompany.com
              </p>
            </div>
            <div className="social-icons">
              <a href="https://www.facebook.com/pages/Proco-Company/207964556208027" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} />
              </a>
              <a href="https://www.google.com/maps/place/8220+Birch+St,+Manassas,+VA+20111" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faGoogle} />
              </a>
            </div>
          </div>
        ) : (
          <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />
          </button>
        )}
      </div>

      {isMobile && menuOpen && (
        <div className="mobile-menu">
          <div className="contact-info">
            <p>Contact us today</p>
            <p>
              <FontAwesomeIcon icon={faPhoneAlt} /> Tel: 703-396-TIRE (8473) <br />
              <FontAwesomeIcon icon={faEnvelope} /> Email: info@prococompany.com
            </p>
          </div>
          <div className="social-icons">
            <a href="https://www.facebook.com/pages/Proco-Company/207964556208027" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://www.google.com/maps/place/8220+Birch+St,+Manassas,+VA+20111" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faGoogle} />
            </a>
          </div>
        </div>
      )}

      <div className="header-bottom">
        <nav className={isMobile ? "mobile-nav" : ""}>
          <ul className={menuOpen ? "open" : ""}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/schedule-pickup">Schedule Pickup</Link></li>
            <li><Link to="/new-customer">New Customer</Link></li>
            <li><Link to="/about">About Us</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
